import { Box, Flex, Heading, HStack, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import { PRODUCTS_TABS } from "../../constants/ui";
import CategorySizeIcon from "../../components/Icons/CategorySizeIcon";
import InsightsResearchIcon from "../../components/Icons/InsightsResearchIcon";
import SMEActivityIcon from "../../components/Icons/SMEActivityIcon";
import FindSuppliersIcon from "../../components/Icons/FindSuppliersIcon";

const ProductLinks = ({ currentTab, changeTab }) => {
  return (
    <HStack>
      <Box m={"0px"} w={"100%"}>
        <Text
          className={
            currentTab === PRODUCTS_TABS.CATEGORY_SIZE
              ? "productSubTabs productSubTabs-selected"
              : "productSubTabs"
          }
          style={{ display: "flex", width: "122px" }}
          _hover={{}}
          onClick={() => changeTab(PRODUCTS_TABS.CATEGORY_SIZE)}
        >
          <Box mr={"5px"}>
            <CategorySizeIcon
              color={
                currentTab === PRODUCTS_TABS.CATEGORY_SIZE
                  ? "#FFFFFF"
                  : "#5D5D5D"
              }
            />
          </Box>
          <Box>Category Size</Box>
        </Text>
      </Box>
      <Box m={"0px"} w={"100%"}>
        <Text
          className={
            currentTab === PRODUCTS_TABS.INSIGHTS_RESEARCH
              ? "productSubTabs productSubTabs-selected"
              : "productSubTabs"
          }
          style={{ display: "flex", width: "145px" }}
          _hover={{}}
          onClick={() => changeTab(PRODUCTS_TABS.INSIGHTS_RESEARCH)}
        >
          <Box mr={"5px"}>
            <InsightsResearchIcon
              color={
                currentTab === PRODUCTS_TABS.INSIGHTS_RESEARCH
                  ? "#FFFFFF"
                  : "#5D5D5D"
              }
            />
          </Box>
          <Box>Insights Research</Box>
        </Text>
      </Box>
      <Box m={"0px"} w={"100%"}>
        <Text
          className={
            currentTab === PRODUCTS_TABS.SME_ACTIVITY
              ? "productSubTabs productSubTabs-selected"
              : "productSubTabs"
          }
          style={{ display: "flex", width: "122px" }}
          _hover={{}}
          onClick={() => changeTab(PRODUCTS_TABS.SME_ACTIVITY)}
        >
          <Box mr={"5px"}>
            <SMEActivityIcon
              color={
                currentTab === PRODUCTS_TABS.SME_ACTIVITY
                  ? "#FFFFFF"
                  : "#5D5D5D"
              }
            />
          </Box>
          <Box>SME Activity</Box>
        </Text>
      </Box>
      <Box m={"0px"} w={"100%"}>
        <Text
          className={
            currentTab === PRODUCTS_TABS.FIND_SUPPLIERS
              ? "productSubTabs productSubTabs-selected"
              : "productSubTabs"
          }
          style={{ display: "flex", width: "122px" }}
          _hover={{}}
          onClick={() => changeTab(PRODUCTS_TABS.FIND_SUPPLIERS)}
        >
          <Box mr={"5px"}>
            <FindSuppliersIcon
              color={
                currentTab === PRODUCTS_TABS.FIND_SUPPLIERS
                  ? "#FFFFFF"
                  : "#5D5D5D"
              }
            />
          </Box>
          <Box>Find Suppliers</Box>
        </Text>
      </Box>
    </HStack>
  );
};

const HeaderProducts = ({ currentTab, changeTab }) => {
  return (
    <>
      <HStack style={{ padding: "5px 10px" }} justifyContent={"space-between"}>
        <Box>
          <Heading
            fontSize="var(--sylvr-h3-fs)"
            fontWeight="var(--sylvr-h3-fw)"
            color="var(--sylvr-text-color)"
            pr={3}
          >
            Food and Kindred Products
          </Heading>
        </Box>
        <HStack>
          <ProductLinks currentTab={currentTab} changeTab={changeTab} />
        </HStack>
      </HStack>
    </>
  );
};

export default HeaderProducts;
